import { Button } from "@components/button";
import "./version-popup.scss";
import { useVersion } from "@contexts/version.context";

export const VersionPopup = () => {
  const { hasUpdate, reload, newAppVersion } = useVersion();

  if (!hasUpdate) return null;

  return (
    <div className="version-popup">
      <h3 className="mb-10 font-medium">New app version available</h3>
      <Button type="button" variant="primary" onClick={reload} size="large">
        Upgrade To {newAppVersion}
      </Button>
    </div>
  );
};
